import React from 'react';
import { GeneralLedgerProvider } from './contexts/GeneralLedgerContext';
import GeneralLedger from './GeneralLedger';
import type {
  DateRange,
  GeneralLedgerFilters,
  SidebarDescriptor,
  DataEntry,
  LedgerAccountCategory,
  Client,
} from './types';
import type { Task } from './components/task-operations/types';

export type GeneralLedgerWithContextProps = {
  dataEntries: Array<DataEntry>;
  dateRange: DateRange;
  defaultFilters?: GeneralLedgerFilters;
  defaultSidebarDescriptor?: SidebarDescriptor;
  hasQualityIssues?: boolean;
  ledgerAccountCategories: Array<LedgerAccountCategory>;
  onFiltersChange?: (filters: GeneralLedgerFilters) => void;
  updateSidebarParams: (sidebarDescriptor?: SidebarDescriptor) => void;
  updateDateRange: (dateRange: DateRange) => void;
  dataEntriesMap: Map<string, DataEntry>;
  isLightningGL: boolean;
  client: Client;
  moneyInTransitLedgerId?: string;
  potentialMatches?: {
    creditTransactions: Map<number, DataEntry[]>;
    debitTransactions: Map<number, DataEntry[]>;
  };
  confirmCategoryTasks?: Array<Task>;
};

const GeneralLedgerWithContext: React.FC<GeneralLedgerWithContextProps> = props => {
  const { client, defaultFilters, defaultSidebarDescriptor, dateRange } = props;

  const initialState = {
    filters: defaultFilters || {
      search: '',
      showAccounts: false,
      showQualityIssues: false,
    },
    dateRange: dateRange || {
      startDate: undefined,
      endDate: undefined,
    },
    sidebarDescriptor: defaultSidebarDescriptor,
    showAccounts: defaultFilters?.showAccounts || false,
    showQualityIssues: defaultFilters?.showQualityIssues || false,
    search: defaultFilters?.search || '',
  };

  return (
    <GeneralLedgerProvider
      initialState={initialState}
      clientId={client.id}
      onFiltersChange={props.onFiltersChange}
    >
      <GeneralLedger {...props} />
    </GeneralLedgerProvider>
  );
};

export default GeneralLedgerWithContext;
